var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Item',{attrs:{"icon":"material-symbols:add-circle-outline-rounded","isSelected":_vm.isSelected,"usage":_vm.clickHandler}})}
var staticRenderFns = []

export { render, staticRenderFns }